import React, { PropTypes } from "react";
import styled from "styled-components";
import { NitroText, NitroIcon } from "nitro-components";

const Container = styled.div`
display:flex;
flex-direction:column;
justify-content:space-between;
margin-top:25px;
cursor:pointer;
`;

const ItemContainer = styled.div`
display:flex;
align-items:center;
justify-content:center;
margin-bottom: ${props => (props.bottom)}px;
margin-top: ${props => (props.top)}px;
`;

const formatDate = rawDate => {
	var monthNames = [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December"
	];

	const date = new Date(rawDate);
	const nth = d => {
		if (d > 3 && d < 21) return "th";
		switch (d % 10) {
			case 1:
				return "st";
			case 2:
				return "nd";
			case 3:
				return "rd";
			default:
				return "th";
		}
	};

	var day = date.getDate();
	var monthIndex = date.getMonth();
	var year = date.getFullYear();

	return `${day}${nth(day)} ${monthNames[monthIndex]} ${year}`;
};

const getValidIndicator = IsValid => {
	let iconName = "failure-circle";
	let variant = "negative";
	let content = "INVALID";

	if (IsValid) {
		iconName = "success-circle";
		variant = "positive";
		content = "VALID";
	}

	return (
		<div>
			<NitroIcon
				name={iconName}
				variant={variant}
				bold
				size={20}
				right={10}
			/>
			<NitroText variant={variant} bold size={14}>
				{content}
			</NitroText>
		</div>
	);
};

const ReportOdometer = props => {
	const { LatestOdo, LatestOdoDate, IsValid, Description } = props.data;
	const {fetchReportDetail} = props;


	return (
		<Container onClick={()=>{fetchReportDetail({fetchVehicleInfoDetail:true})}}>
			<ItemContainer bottom={22}>
				{getValidIndicator(IsValid)}
			</ItemContainer>
			<ItemContainer bottom={8}>
				<NitroText variant="base1" size={55}>{LatestOdo}</NitroText>
			</ItemContainer>
			<ItemContainer bottom={25}>
				<NitroText variant="base3" bold size={14}>
					{formatDate(LatestOdoDate)}
				</NitroText>
			</ItemContainer>
			<ItemContainer bottom={0} top={20}>
			<NitroText variant="base3"  size={12}>
					SEE ODOMETER HISTORY
				</NitroText>
			</ItemContainer>
		</Container>
	);
};

ReportOdometer.propTypes = {
	data: PropTypes.object,
	fetchReportDetail: PropTypes.func
};

export default ReportOdometer;



// WEBPACK FOOTER //
// ./src/features/dashboard/components/reports/ReportOdometer.js